<template>
  <el-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="snDetailsEdit.pkid > 0 ? '编辑' : '新建'"
      width="900px"
      top="10vh"
      @close="$reset('form')">
    <el-form
        ref="form"
        :model="snDetailsEdit"
        :rules="ruleValidate"
        class="form"
        label-width="80px">
      <el-row>
        <el-col :span="12">
          <el-form-item label="元码编号" prop="metaDataNo">
            <el-select v-model="snDetailsEdit.metaDataNo" clearable placeholder="请选择元码编号">
              <el-option
                  v-for="(item, index) in metaDataNoList"
                  :key="index"
                  :label="item.value"
                  :value="item.key"
                  @click.native="selectMetaDataNo(item.value)"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="标签个数">
            <el-input v-model="snDetailsEdit.lableLength" placeholder="请输入标签个数"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="源码标签">
            <el-input v-model="snDetailsEdit.metaDataLable" placeholder="请输入源码标签"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="源码名称">
            <el-input v-model="snDetailsEdit.metaDataName" placeholder="请输入源码名称"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="数据源">
            <el-input v-model="snDetailsEdit.dataSource" placeholder="请输入数据源"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="后缀">
            <el-input v-model="snDetailsEdit.suffixChar" placeholder="请输入后缀"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="是否验证">
            <el-radio-group v-model="snDetailsEdit.isVerify">
              <el-radio :label="false">否</el-radio>
              <el-radio :label="true">是</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {
    name: "BarCodeRulesDetailsEdit",
    data() {
      return {
        dialogVisible: false,
        submitLoading: false,
        metaDataNoList: [],
        snDetailsEdit: {
          pkid: 0,
          rowIndex: "",
          metaDataNo: "",
          metaDataDesc: "",
          metaDataLable: "",
          metaDataName: "",
          lableLength: "",
          dataSource: "",
          suffixChar: "",
          isVerify: false,
        },
        ruleValidate: {
          metaDataNo: { required: true, message: "请选择元码", trigger: "change" },
        },
      };
    },
    methods: {
      open(row, index) {
        this.index = index;
        this.dialogVisible = true;
        this.getMetaDataNoList();
        if (row) {
          this.snDetailsEdit = Object.assign(this.snDetailsEdit, row);
        }
      },

      selectMetaDataNo(value) {
        this.snDetailsEdit.metaDataDesc = value;
      },

      // 获取元码编号
      getMetaDataNoList() {
        this.$http.get("basic", "snRule/selectMetaDataNos").then((resp) => {
          if (resp.success) {
            this.metaDataNoList = resp.data;
          }
        });
      },

      handleSubmit() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            if (this.index < 0) {
              this.dialogVisible = false;
              this.$emit("save-success", this.snDetailsEdit);
            } else {
              this.dialogVisible = false;
              this.$emit("save-success", this.snDetailsEdit, this.index);
            }
          }
        });
      },
    },
  };
</script>
